var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.201 16.093v-7.34h2.363l.353-2.862H5.201V4.065c0-.828.22-1.393 1.36-1.393h1.452V.111A18.647 18.647 0 0 0 5.896 0C3.802 0 2.37 1.333 2.37 3.782v2.11H0v2.86h2.369v7.341H5.2Z",
    fill: "#7F7B71"
  })));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDkgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4yMDEwNCAxNi4wOTMyVjguNzUyMzZINy41NjM1Nkw3LjkxNzI2IDUuODkxNDZINS4yMDEwNFY0LjA2NDkxQzUuMjAxMDQgMy4yMzY2MiA1LjQyMTU0IDIuNjcyMTggNi41NjA0MSAyLjY3MjE4TDguMDEyOTQgMi42NzE0N1YwLjExMjcxN0M3Ljc2MTY2IDAuMDc3OTE0NiA2Ljg5OTQ3IDAgNS44OTYzOSAwQzMuODAyMTggMCAyLjM2ODUxIDEuMzMzMjEgMi4zNjg1MSAzLjc4MTY2VjUuODkxNDZIMFY4Ljc1MjM2SDIuMzY4NTFWMTYuMDkzMkg1LjIwMTA0WiIgZmlsbD0iIzdGN0I3MSIvPgo8L3N2Zz4K";